import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import {PdfpersectionService} from '../pdfpersection.service'
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pdfpersection',
  templateUrl: './pdfpersection.component.html',
  styleUrls: ['./pdfpersection.component.sass']
})
export class PdfpersectionComponent implements OnInit {

  loader = true;
  items: any;
  nodata = false;
  p = 1;
  _id: string;
  searchText = '';
  query: any = {
    page: 1,
    limit: environment.defaultPageSize,
    userType: 1
  };
  recordsPerPage: number;
  totalRecords = 0;

  constructor(
    private router: Router,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private PdfpersectionService: PdfpersectionService,
  ){ 
    this.recordsPerPage = environment.defaultPageSize;
  }

  ngOnInit() {
    this.getpdflistdata()
  }
  getpdflistdata(){
    this.query.search = this.searchText;
    this.PdfpersectionService.getpdfV2(this.query).subscribe((result: any) => {
      const items = result.data;
      this.items = items;
      this.totalRecords = result.totalCount;
      this.loader = false;
      this.nodata = false;
    }, (error: any) => {
      this.nodata = true;
      this.loader = false;
      });
  }

  pageChanged(event: any): void {
    this.p = event.page;
    this.query.page = this.p;
    this.getpdflistdata();
  }

  delteCause(id) {
    const obj = {
      _id: id
    };
    this.PdfpersectionService.deletepdf(id).subscribe((result: any) => {
      this.loader = false;
      if (result.success === true) {
        this.commonService.toast(result.message, 'Success');
      } else {
        this.commonService.toast(result.message, 'Error');
      }
      this.getpdflistdata();
    }, (error: any) => {
      this.loader = false;
      this.commonService.toast(error.error.message, 'Error');
    });
  }

  public getRoute(url, id) {
    const myurl = `${url}/${id}`;
    this.router.navigateByUrl(myurl).then(e => {
      if (e) {
        // console.log("Navigation is successful!");
      } else {
        console.log('Navigation has failed!');
      }
    });
  }

  navigateAddCause() {
    this.router.navigate(['/pdfpersection/add']);
  }
}
